import React from 'react'

export const WhiteLabel = ({primerDato,segundoDato}) => {
  return (
    <div className='whiteLabel'>
         <p className='texto' >{primerDato} </p>
         <p className='textoDos' >{segundoDato}</p>
        

        </div>
  )
}
